import React from 'react'
import { useS4LContext } from '@s4l/react-context'

import { BottomSheet, Typography } from '@s4l/ds'
import AlertMessage from 'src/comps/AlertMessage'
import VoucherGuestRoomListForm from './Form'

import styles from './styles.module.css'

interface IVoucherGuestRoomListModalProps {
  hash: string
  bookNumber: number
  isMultiBooking: boolean
  isOpen: boolean
  onClose: () => void
  pendingRoomingListCount: number
  totalGuests: number
  initialGuest: Omit<GuestData, 'country'>
  purchaseId: string
}

interface GuestData {
  id: string
  firstName: string
  lastName: string
  country: {
    code: string
    name: string
  }
}

const ALERT_CONTAINER_ID = 'voucher-guest-room-list-modal'

const VoucherGuestRoomListModal = ({
  hash,
  bookNumber,
  isOpen,
  isMultiBooking,
  onClose,
  pendingRoomingListCount,
  purchaseId,
  totalGuests,
  initialGuest,
}: IVoucherGuestRoomListModalProps) => {
  const { i18n } = useS4LContext()

  const titleMessage = isMultiBooking
    ? i18n.formatMessage({ id: 'guest-rooming-list.multibooking' }, { count: bookNumber })
    : i18n.formatMessage({ id: 'global.guest-details-default' }, { count: totalGuests })

  return (
    <BottomSheet autoFocus open={isOpen} onClose={onClose}>
      <BottomSheet.Content title={titleMessage} modalOnDesktop scroll>
        <div className={styles.content}>
          <AlertMessage containerId={ALERT_CONTAINER_ID} />

          <Typography variant="body" size="m">
            {i18n.formatMessage({ id: 'guest-rooming-list.body' })}
          </Typography>

          <VoucherGuestRoomListForm
            alertContainerId={ALERT_CONTAINER_ID}
            hash={hash}
            initialGuest={initialGuest}
            isMultiBooking={isMultiBooking}
            onClose={onClose}
            pendingRoomingListCount={pendingRoomingListCount}
            purchaseId={purchaseId}
            totalGuests={totalGuests}
          />
        </div>
      </BottomSheet.Content>
    </BottomSheet>
  )
}

export default VoucherGuestRoomListModal
